import type { IDiscountActivity } from '@wegic/price-ui';

export function getCampaignEndTimestamp(
  discountActivity?: Pick<IDiscountActivity, 'endTime'> | null,
  now = Date.now(),
): number | null {
  const timestamp = new Date(discountActivity?.endTime || '').getTime();

  return Number.isNaN(timestamp) || timestamp <= now ? null : timestamp;
}
